import {
  Form,
  Space,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import BenefitForm from '../../forms/BenefitForm';
import { editBenefit, getBenefit } from '../../services/benefitServices';

function EditBenefit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (key === 'image') {
          if (values[key]?.file) {
            formData.append(key, values[key].file);
          } else {
            formData.append(key, values[key].fileList[0].url);
          }
        } else {
          // eslint-disable-next-line no-unused-expressions
          values[key] && formData.append(key, values[key]);
        }
      });
      const res = await editBenefit(id, formData);
      if (res.status === 'success') {
        navigate('/admin/benefits');
      }
    } catch (e) {
      setErrors(e?.response?.data?.errors);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await getBenefit(id);
      if (res.status === 'success') {
        res.data.image = {
          fileList: [{
            uid: 1,
            url: res.data.image,
            name: res.data.title_ka,
          }],
        };
        form.setFieldsValue(res.data);
      }
    };
    fetchData();
  }, [id]);

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/benefits')}
      />
      <BenefitForm
        form={form}
        errors={errors}
        handleSubmit={handleSubmit}
      />
    </Space>

  );
}
export default EditBenefit;
